<template>
  <div class="sectionOuterBox bgLightGrey">
    <div class="sectionInnerBox">
      <div class="container d-flex headlineText">
        <span class="text31 schoolHeadlineText">
          {{ $t('schools.headline2.description') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Headline2 extends Vue {
}
</script>

<style lang="scss" scoped>
.headlineText {
  max-width: 780px;
  line-height: normal;
}

.text31 {
  font-size: 31px;
}

.schoolHeadlineText {
  min-height: 112px;
  margin: 8px 0;
}
</style>
